import React, { useState, useEffect } from 'react';
import CommissionPaymentComponent from './CommissionPaymentComponent';
import CommissionPaymentTable from './CommissionPaymentTable';
import { getCommission_bulletinsToPay, clearCommission_bulletins } from '../../flux/actions/commissionbulletinActions';
import ConfirmCommissionPayment from './ConfirmCommissionPayment';
import { Container, Row } from 'reactstrap';

import { connect } from 'react-redux';
import { CommissionPaymentContainer, ICommissionPaymentContainerReduxProps } from '../../types/interfaces';
import Loading from '../../components/Loading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'

import { useBeforeunload } from 'react-beforeunload';

import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";

const CommissionPaymentContainerComponent = ({ 
  getCommission_bulletinsToPay,
  clearCommission_bulletins,
  commission_bulletin
 }: CommissionPaymentContainer) => {

  const { commission_bulletins, loading } = commission_bulletin;
  const [tableData, setTableData] = useState(commission_bulletins);
  const [selectedRows, setSelectedRows] = useState(Array());
  const [clearFilters, setClearFilters] = useState(false);

  const [selectedUser, setSelectedUser] = useState<any>('');
  const [societeValue, setSocieteValue] = useState({id: "ALL", name: "Toutes les sociétés"});
  // const [societeValue, setSocieteValue] = useState({value: "RUTAS", label: "RUTAS"});
  const [commentValue, setCommentValue] = useState('');

  useBeforeunload((e) => {
    if(selectedRows.length)
      e.preventDefault();
  });

  const clearInputs = () => {
    setSelectedUser('');
    setCommentValue('');
  }

  useEffect(() => {
    clearCommission_bulletins();
    if(selectedUser && societeValue)
      // getCommission_bulletinsToPay("", selectedUser["id"], societeValue["value"]);
      getCommission_bulletinsToPay(selectedUser["id"], societeValue["id"]);
  }, [getCommission_bulletinsToPay, selectedUser, societeValue]);

  useEffect(() => {
    return () => clearCommission_bulletins()
  }, []);

  useEffect(() => {
    setTableData(commission_bulletins.map(e => {
      const toPay = Number((e.commission_bulletin_lines || []).reduce((n, t) => n + Number(t.commission || 0) + Number(t.bonus_malus || 0), 0).toFixed(2)) + Number(e.bonus_malus || 0)
      const left = Number((toPay - Number(Number(e.paid || 0).toFixed(2))).toFixed(2))
      if(e.id === 189) console.log(toPay, left, e.paid)
      return e.toPay = toPay, e.left = left, e.left_table = left, e;
    }));
  }, [commission_bulletins]);

  return (
    <>
      <Container><h2 className="title"><FontAwesomeIcon icon={faFileInvoiceDollar} />&nbsp;&nbsp;Paiement des Commissions</h2></Container>
      <CommissionPaymentComponent 
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        societeValue={societeValue}
        setSocieteValue={setSocieteValue}
        commentValue={commentValue}
        setCommentValue={setCommentValue} />
      {loading ? <Loading topSpace /> : <CommissionPaymentTable linesData={tableData} setTableData={setTableData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} clearFilters={clearFilters} setClearFilters={setClearFilters} showComColumn={selectedUser?.id === "ALL"} fromPayment />}
      <ConfirmCommissionPayment linesData={selectedRows} 
        clearInputs={clearInputs}
        selectedUser={selectedUser}
        societeValue={societeValue}
        commentValue={commentValue}
        setClearFilters={setClearFilters} />
    </>
  );
};

const mapStateToProps = (state: ICommissionPaymentContainerReduxProps) => ({
  commission_bulletin: state.commission_bulletin
});

export default connect(mapStateToProps, { getCommission_bulletinsToPay, clearCommission_bulletins })(CommissionPaymentContainerComponent);
